/**
 * Single source of truth for environment checks in new code.
 * `NEXT_PUBLIC_ENV` uses `local`/`stage`/`prod` (matches the existing
 * `providerRecovery`/Datadog convention). Existing inline checks are kept as-is.
 */
export const isProductionEnv = (): boolean => process.env.NEXT_PUBLIC_ENV === "prod";
